module.exports = __webpack_public_path__ + "img/hero-phone.1dbf0dfe.jpg";